class ComponentTabs extends Theme.Component {
  connectedCallback() {
    if (this.elements.tabs.length === 0) {
      return;
    }

    this.elements.tabs.forEach((tab) => {
      this.addDirectEvent("click", tab, () => this.select(tab));
      this.addDirectEvent("keydown", tab, this.onKeydown.bind(this));
    });
  }

  select(tab) {
    const index = this.elements.tabs.indexOf(tab);

    if (index === -1) {
      return;
    }

    this.elements.tabs.forEach((element, position) => {
      const is_active = position === index;

      element.setAttribute("aria-selected", is_active);
      element.setAttribute("tabindex", is_active ? "0" : "-1");
    });

    this.elements.panels.forEach((panel) => {
      if (panel.hasAttribute("hidden")) {
        return;
      }

      panel.querySelector("component-scroll")?.rememberPosition();
    });

    this.elements.panels.forEach((panel, position) => {
      panel.toggleAttribute("hidden", position !== index);
    });

    const scroll = this.elements.panels[index]?.querySelector("component-scroll");

    scroll?.refresh();
    scroll?.restorePosition();
  }

  onKeydown(event) {
    const steps = { ArrowLeft: -1, ArrowRight: 1 };
    const step = steps[event.key];

    if (!step) {
      return;
    }

    event.preventDefault();

    const tabs = this.elements.tabs;
    const current = tabs.indexOf(event.currentTarget);
    const next = (current + step + tabs.length) % tabs.length;

    this.select(tabs[next]);
    tabs[next].focus();
  }
}

customElements.define("component-tabs", ComponentTabs);
